import { listVal } from "@paroi/data-formatters-lib";
import type CreateRelationInput from "../domain/relation";
import { fetchQuery } from "../shared/http-client";
import {
  type Relation,
  type RelationType,
  formatToRelation,
  formatToRelationType,
} from "./relation.formatter";

export async function createRelationAPI(
  referenceId: string,
  input: CreateRelationInput,
): Promise<void> {
  await fetchQuery(`references/${referenceId}/relations`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function fetchRelationsAPI(referenceId: number): Promise<Relation[]> {
  const res = await fetchQuery(`references/${referenceId}/relations`);
  return listVal(res.data, formatToRelation);
}

export async function fetchOneRelationAPI(
  referenceId: string,
  relationId: string,
): Promise<Relation> {
  const res = await fetchQuery(`references/${referenceId}/relations/${relationId}`);
  return formatToRelation(res.data);
}

export async function deleteRelationAPI(referenceId: number, relationId: number): Promise<void> {
  await fetchQuery(`references/${referenceId}/relations/${relationId}`, {
    method: "DELETE",
  });
}

export async function updateRelationAPI(
  referenceId: string,
  relationId: string,
  input: CreateRelationInput,
): Promise<void> {
  await fetchQuery(`references/${referenceId}/relations/${relationId}`, {
    method: "PUT",
    body: JSON.stringify(input),
  });
}

export async function fetchRelationTypesAPI(): Promise<RelationType | undefined> {
  const res = await fetchQuery("relations/types");
  return formatToRelationType(res);
}
